import React from "react";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";

const FeaturedText = ({ data }: any) => {
  return (
    <div className="flex flex-col md:flex-row md:gap-[58px]">
      <div className="w-full md:w-2/5">
        <h2 className="!text-[76px] leading-[1.05] !font-light mb-8 md:mb-0 md:leading-tight md:text-[64px] sm:text-[48px] break-normal">
          {data?.header}
        </h2>
      </div>
      <div className="w-full md:w-3/5 text-base md:text-lg">
        {documentToReactComponents(data?.featuredContent?.json)}
      </div>
    </div>
  );
};

export default FeaturedText;
